export const DATE_FORMATS = {
  FULL_YEAR: /YYYY/,
  SHORT_YEAR: /(?<!Y)YY(?!Y)/,
  FULL_MONTH: /MM/,
  SHORT_MONTH: /(?<!M)M(?!M)/,
  FULL_DAY: /DD/,
  SHORT_DAY: /(?<!D)D(?!D)/,
  FULL_HOUR: /HH/,
  SHORT_HOUR: /(?<!H)H(?!H)/,
  FULL_MINUTES: /mm/,
  SHORT_MINUTES: /(?<!m)m(?!m)/,
  FULL_SECONDS: /ss/,
  SHORT_SECONDS: /(?<!s)s(?!s)/,
}